import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Datalist from '../../../../components/form/Datalist';
import Input from '../../../../components/form/Input';
import InputCadastro from '../../../../components/form/InputCadastro';
import useFetch from '../../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';
import {
  ENDERECOS_BUSCA_CEP,
  ENDERECOS_BUSCA_PAIS,
  ENDERECOS_INCLUIR,
} from '../../../../services/endereco';
import { MEUCORREIOS_PESQUISA } from '../../../../services/meuCorreios';
import { createFormSchemas } from './FormSchema';
import './TelaNovoEndereco.scss';

const TelaNovoEndereco = () => {
  const { t } = useTranslation();
  const { formSchemaNovoEndereco } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaNovoEndereco) });
  const navigate = useNavigate();
  const { request } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const idCorreios = dados[0];
  const ipAddress = dados[1];
  const [logradouro, setLogradouro] = React.useState();
  const [bairro, setBairro] = React.useState();
  const [cidade, setCidade] = React.useState();
  const [uf, setUf] = React.useState();
  const [isBrasil, setIsBrasil] = useState(true);
  const [temLogradouro, setTemLogradouro] = useState(true);
  const [desabilitarSemNumero, setDesabilitarSemNumero] = useState(false);
  const [desabilitarNumero, setDesabilitarNumero] = useState(false);

  //  const [listaPais, setListaPais] = useState({});
  const [listaPais, setListaPais] = useState({
    value: 'BR',
    label: 'BRASIL',
  });

  const { request: requestMeuCorreios, data: dadosUsuario } = useFetch();
  useEffect(() => {
    if (idCorreios && idCorreios != '') {
      requestMeuCorreios(MEUCORREIOS_PESQUISA(idCorreios));
    }
  }, [idCorreios]);

  useEffect(() => {
    if (
      dadosUsuario?.usuarioExternoPF?.tipoEstrangeiro === 'B' ||
      dadosUsuario?.usuarioExternoPF?.tipoEstrangeiro === 'E'
    ) {
      setListaPais(undefined);
    } else {
      setListaPais({
        value: 'BR',
        label: 'BRASIL',
      });
    }
  }, [dadosUsuario]);

  const chamaEndereco = () => {
    navigate('/endereco');
  };
  const [isCheckedSemNumero, setIsCheckedSemNumero] = useState(false);
  const handleSemNumero = () => {
    setIsCheckedSemNumero(!isCheckedSemNumero);
  };
  useEffect(() => {
    if (isCheckedSemNumero) {
      setDesabilitarNumero(true);
      document.getElementById('numero').value = '';
    } else {
      setDesabilitarNumero(false);
    }
  }, [isCheckedSemNumero]);
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const { request: requestLogradouro, data: dadosLogradouro } = useFetch([]);

  useEffect(() => {
    if (dadosLogradouro) {
      setLogradouro(dadosLogradouro.logradouro);
      setBairro(dadosLogradouro.bairro);
      setCidade(dadosLogradouro.localidade);
      setUf(dadosLogradouro.uf);
    }
  }, [dadosLogradouro]);

  const handleBlur = (e) => pesquisaLogradouro(e.target.value);
  async function pesquisaLogradouro(texto) {
    if (!texto) {
      limpaCep();
      return;
    }

    if (texto.length === 8) {
      const retornoPesquisaLogradouro = await requestLogradouro(
        ENDERECOS_BUSCA_CEP(texto),
      );
      if (retornoPesquisaLogradouro?.json?.uf === undefined) {
        abreAlertaDialog(t('principal.addresses.messages.invalid_cep'));
      } else {
        if (retornoPesquisaLogradouro?.json?.logradouro === undefined) {
          setTemLogradouro(false);
        } else {
          setTemLogradouro(true);
        }
      }
    } else {
      abreAlertaDialog(t('principal.addresses.messages.cep_format'));
    }
  }

  function limpaCep() {
    setLogradouro('');
    setBairro('');
    setCidade('');
    setUf('');
  }

  const handleSubmit = async (data) => {
    data.preventDefault;
    if (isCheckedSemNumero) {
      data.numero = 'S/N';
    }
    let dadosEnviar = {
      principal: 'N',
      numero: data.numero,
      ddiFixo: isBrasil ? '55' : data.ddiFixo,
      dddFixo: data.dddFixo,
      foneFixo: data.foneFixo,
      siglaPais: data.siglaPais?.value,
      identificacao: data.identificacao,
      complemento: data.complemento,
    };

    if (dadosLogradouro.localidade) {
      dadosEnviar = {
        cidade: dadosLogradouro.localidade,
        bairro: temLogradouro ? dadosLogradouro.bairro : data.bairro,
        uf: dadosLogradouro.uf,
        logradouro: temLogradouro
          ? dadosLogradouro.logradouro
          : data.logradouro,
        codigoPostal: dadosLogradouro.cep,
        ...dadosEnviar,
      };
    } else {
      dadosEnviar = {
        cidade: data.cidade,
        bairro: data.bairro,
        uf: data.uf,
        logradouro: data.logradouro,
        codigoPostal: data.codigoPostal,
        ...dadosEnviar,
      };
    }
    delete dadosEnviar['isBrasilHidden'];
    const { response } = await request(
      ENDERECOS_INCLUIR(idCorreios, dadosEnviar, ipAddress),
    );

    if (response.ok) {
      abreAlertaDialog(t('principal.addresses.messages.added_success'));
      chamaEndereco();
    }
  };

  const handleReset = () => {
    limpaCep();
    const form = document.getElementById('formNovoEndereco');
    const campos = form.querySelectorAll('input, select');
    campos.forEach((campo) => {
      if (campo.type !== 'hidden') {
        campo.value = '';
      }
    });
  };

  const pesquisaPaises = async (value, request) => {
    const { json } = await request(ENDERECOS_BUSCA_PAIS(value));
    return json.map((pais) => ({
      value: pais.sigla,
      label: pais.nome,
    }));
  };

  function changePais(pais) {
    setIsBrasil(pais?.value === 'BR');
  }

  useEffect(() => {
    document.getElementById('isBrasilHidden').value = isBrasil;
  }, [isBrasil]);
  const handleNumero = (event) => {
    const valoresInvalidos = ['sn', 's/n', 's n', 'sem numero'];
    if (
      event.target.value.trim() === '' ||
      valoresInvalidos.includes(event.target.value.trim().toLowerCase())
    ) {
      setDesabilitarSemNumero(false);
    } else {
      setDesabilitarSemNumero(true);
    }
  };
  return (
    <div className="conteudo cadastro-endereco">
      <div id="cadastro-endereco" className="card bg-superficie elev5">
        <h1>{t('principal.addresses.new_address')}</h1>

        <form
          id="formNovoEndereco"
          autocomplete="off"
          onSubmit={methods.handleSubmit(handleSubmit)}
        >
          <Datalist
            async={true}
            loadOptions={(value) => pesquisaPaises(value, request)}
            name="siglaPais"
            label={t('principal.addresses.country_search_hint')}
            defaultValue={listaPais}
            value={listaPais}
            onChange={(texto) => {
              setListaPais(texto);
              changePais(texto);
            }}
            {...formMethods}
          />

          <Input
            type="hidden"
            id="isBrasilHidden"
            name="isBrasilHidden"
            defaultValue={isBrasil}
            {...formMethods}
          />
          {!isBrasil ? (
            <>
              <div id="aviso-exterior" className="legenda">
                {t('principal.addresses.international_warning')}
              </div>
              <hr />
              <InputCadastro
                type="text"
                id="codigoPostal"
                name="codigoPostal"
                placeholder=""
                maxLength="8"
                label="Código Postal"
                {...formMethods}
              />
            </>
          ) : (
            <InputCadastro
              type="text"
              id="codigoPostal"
              name="codigoPostal"
              placeholder=""
              maxLength="8"
              label={t('principal.addresses.cep')}
              onBlur={handleBlur}
              {...formMethods}
            />
          )}
          <InputCadastro
            type="text"
            id="logradouro"
            name="logradouro"
            placeholder=""
            label={t('principal.addresses.street')}
            disabled={isBrasil && temLogradouro}
            defaultValue={logradouro}
            {...formMethods}
          />

          <div className="container-num-comp">
            <InputCadastro
              type="text"
              id="numero"
              name="numero"
              maxLength="10"
              className="campo-numero"
              campoClassName="campo-numero"
              placeholder=""
              label={t('principal.addresses.number')}
              autocomplete="number"
              disabled={desabilitarNumero}
              onBlur={handleNumero}
              {...formMethods}
            />

            <label className="input-checkbox">
              <Input
                type="checkbox"
                id="sn"
                name="sn"
                disabled={desabilitarSemNumero}
                onClick={handleSemNumero}
                checked={isCheckedSemNumero}
                {...formMethods}
              />
              <div className="subtitulo-p">
                {t('principal.addresses.no_number_check')}
              </div>
            </label>
          </div>

          <InputCadastro
            type="text"
            id="complemento"
            name="complemento"
            maxLength="100"
            className="campo-comp"
            campoClassName="campo-comp"
            placeholder=""
            label={t('principal.addresses.complement')}
            {...formMethods}
          />

          <div className="container-cidade-uf">
            <InputCadastro
              type="text"
              id="bairro"
              name="bairro"
              placeholder=""
              label={t('principal.addresses.neighborhood')}
              campoClassName="campo-bairro"
              disabled={isBrasil && temLogradouro}
              defaultValue={bairro}
              {...formMethods}
            />

            <InputCadastro
              type="text"
              id="cidade"
              name="cidade"
              placeholder=""
              label={t('principal.addresses.city')}
              campoClassName="campo-cidade"
              disabled={isBrasil}
              defaultValue={cidade}
              {...formMethods}
            />

            <InputCadastro
              type="text"
              id="uf"
              name="uf"
              className="campo-uf"
              placeholder=""
              label="Uf"
              campoClassName="campo-uf"
              disabled={isBrasil}
              defaultValue={uf}
              {...formMethods}
            />
          </div>

          <div className="container-telefone">
            {!isBrasil && (
              <InputCadastro
                type="text"
                className="col-1"
                campoClassName="campo-ddd"
                id="ddiFixo"
                name="ddiFixo"
                maxLength="3"
                label="DDI"
                {...formMethods}
              />
            )}

            <InputCadastro
              type="text"
              className="col-1"
              campoClassName="campo-ddd"
              id="dddFixo"
              name="dddFixo"
              maxLength="3"
              label="DDD"
              {...formMethods}
            />

            <InputCadastro
              type="text"
              id="foneFixo"
              name="foneFixo"
              label={t('principal.addresses.phone')}
              maxLength="10"
              {...formMethods}
            />
          </div>

          <div className="campo-txt campo-id">
            <InputCadastro
              type="text"
              id="identificacao"
              name="identificacao"
              placeholder=""
              label={t('principal.addresses.identification')}
              maxLength="20"
              {...formMethods}
            />
            <div className="mensagem legenda">
              {t('principal.addresses.identification_example')}
            </div>
          </div>

          <div className="btns-row">
            <button
              id="btn-adicionar"
              type="submit"
              className="btn-pre primario"
            >
              {t('principal.addresses.add')}
            </button>

            <button
              id="btn-limpar"
              type="reset"
              className="btn-txt"
              onClick={handleReset}
            >
              {t('cadastro.forms.buttons.clear')}
            </button>

            <button
              id="btn-voltar"
              type="button"
              className="btn-txt"
              onClick={() => chamaEndereco()}
            >
              {t('principal.forms.buttons.cancel')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TelaNovoEndereco;
